import { Input } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Component, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { SurveyEditorService } from './survey-editor.service';
import { Location } from '@angular/common';

declare var joint:any;
declare var app:any;

@Component({
  selector: 'app-survey-editor',
  templateUrl: './survey-editor.component.html',
  styleUrls: ['./survey-editor.component.scss']
})

export class SurveyEditorComponent implements OnInit {
  paper!: any;
  graph!: any;
  scroller!: any;
  selected_question_view: any;
  selected_question_object: any;

  selected_link_view: any;
  selected_link_object: any;

  private selection: any = null;

  public withQuestions: boolean;
  public withTips: boolean;
  public withPopups: boolean;
  public withActions: boolean;

  //@Output() exit = new EventEmitter();
  @Input() survey:any = {};
  @Input() events:Observable<any>; 

  @Output() saveEventEmitter: EventEmitter<any> = new EventEmitter();
  eventsSubs: Subscription;

  constructor(seService: SurveyEditorService, private location: Location) {
    seService.useQuestions();
    this.withQuestions = seService.isUsingQuestions;
    this.withTips = seService.isUsingTips;
    this.withPopups = seService.isUsingPopups;
    this.withActions = seService.isUsingActions;
    
   }
  ngOnInit(): void {

    var _this = this;

    this.graph = new joint.dia.Graph();
    this.paper = new joint.dia.Paper({
        model: this.graph,
        width: 3000,
        height: 1000,
        gridSize: 10,
        linkPinning: false,
        markAvailable: true,
        validateConnection: function (cellViewS:any, magnetS:any, cellViewT:any, magnetT:any, end:any, linkView:any) {

          // Interdiction de créer un lien ayant pour source un Input
          if (magnetS && magnetS.getAttribute('type') === 'input') return false;
          
          // interdiction de créer un lien réentrant dans la même question
          if (cellViewS === cellViewT) 
              return false;

          // interdiction de créer un lien ayant pour sortie un point de sortie
          if (magnetT && magnetT.getAttribute('port-group') == 'out') 
              return false;

          if (magnetT && cellViewT) {
              var isRecusrive = _this.checkQuestionGoesToOther(cellViewT, cellViewS.model.attributes.id, null);
              return !isRecusrive;
          }

          return true;
      },
      validateMagnet: function (cellView, magnet) {
          // détermine si un magnet peut être source d'un lien ou non
          var isOk = magnet.getAttribute('magnet') !== 'passive';
          return isOk;
      },
      defaultLink: new joint.dia.Link({
          router: {
              name: 'manhattan'
          },
          connector: { name: 'rounded' },
          attrs: {
            '.connection-wrap': { stroke: '#6a6c8a', 'stroke-width': 10, fill: 'none', 'opacity': 0 },
            '.link-tools': { display: 'none' },
            '.marker-vertices': { display: 'none' },
            '.marker-arrowhead': { display: 'none' },
            '.marker-target': { d: 'M 10 0 L 0 5 L 10 10 z', fill: 'rgba(22,215,36,.8)', stroke: 'rgba(22,215,36,.8)', opacity: 1 },
            '.connection': { stroke: 'rgba(22,215,36,.8)', 'stroke-width': 2, fill: 'none', 'pointer-events' : 'none' }
        },
          condition: {}
      }),
      snapLinks: { radius: 75 },
      interactive: { vertexAdd: false, labelMove: false } // disable default vertexAdd interaction
    });

    this.selection = new app.Selection({paper: this.paper});

    this.scroller = new joint.ui.PaperScroller({
        paper: this.paper,
        autoResizePaper: true,
        cursor: 'grab'
    });

    this.scroller.setCursor('crosshair');

    $('#paper-container').append(this.scroller.render().el);

    this.paper.on('blank:pointerdown', this.scroller.startPanning);
    
    // gestion de la sélection (multiple et simple)
    this.paper.on('cell:pointerup', function(cellView:any, evt:any){
      if (evt.ctrlKey || evt.metaKey) {
        var before = _this.selection.length;
        _this.selection.push(cellView.model);
        if (before == _this.selection.length) {
          _this.selection.remove([cellView.model]);
        }
      } else {
        _this.selection.models.map(function (o:any) {
              var view = _this.paper.findViewByModel(o);
              //this.unHighlightView(view);
          });
          _this.selection.reset([cellView.model]);
          _this.selected_question_view = _this.paper.findViewByModel(_this.selection.models[0]);
          if (_this.selected_question_view)
            _this.selected_question_object = JSON.parse(JSON.stringify(_this.selected_question_view.model.attributes));
          else
            _this.selected_question_object = null;
      }
    });

    this.paper.on('blank:pointerdown', function (cellView: any) {
      _this.selection.models.map(function (o: any) {
          var view = _this.paper.findViewByModel(o);
          //_this.unHighlightView(view);
      });
      _this.selection.reset([]);
      _this.selected_question_object = null;
    });
    if (this.events != null){
      this.eventsSubs = this.events.subscribe((result:any)=> {
        _this.loadSurvey(_this.graph, result);
      });
    }
  }

  clear(): void{
    this.graph.clear();
  }

  clearSelection(): void{
    
    this.selection.models.map(function (o) {
      o.remove();
    });
    this.selection.reset();
  }

  zoom(factor: any): void{
    this.scroller.zoom(0.05 * factor, { min: 0.05, max: 1.5 });
  }

  save(withExit:boolean){
    this.getSurveyForSave();
    this.saveEventEmitter.emit(withExit);
  }

  exit(): void {
    this.location.back()
  }

  addCanvasItem(item: any, x:any, y:any){
    this.selected_question_object = this.selected_question_view = null;

    var zoomRatio = this.scroller.zoom();

    var scrollX = this.scroller.el.scrollLeft;
    var scrollY = this.scroller.el.scrollTop;

    var posX = x / zoomRatio + scrollX / zoomRatio - 50;
    var posY = y / zoomRatio + scrollY / zoomRatio - 30;

    item.attributes.position = { x: posX, y: posY };

    item.addTo(this.graph);

    var cellView = item.findView(this.paper);

    this.selection.reset([cellView.model]);
  }

  drag(event: any){
    event.dataTransfer.setData("text", event.target.id);
  }

  drop(event: any){

    event.preventDefault();
    event.stopPropagation();
    
    // récupération du type d'objet posé
    var data = event.dataTransfer.getData("text");

    // instantiation de l'objet en fonction du type souhaité
    var obj:any;
    if (data == "add-question") {
      obj = new joint.shapes.qad.Question({ questionShort: '', question: '', typequestion: 1 });
    } else if (data == "add-alert") {
      obj = new joint.shapes.qad.Action({
        alert: 'Action', actionType: 0
    });
    } else if (data == "add-tip") {
      obj = new joint.shapes.qad.Tip({ title: 'Fiche conseil' });
    } else if (data == "add-popup") {
      obj = new joint.shapes.qad.Popup({ title: 'Popup' });
    } else
    {
      // type non géré
      console.error('Not able to drop this kind of object on the editor');
      return;
    }
    
    // récupération des coordonnées de l'endroit où l'objet a été posé
    var x = 0;
    var y = 0;
	
		x = event.pageX - ($('#paper-container')?.offset()?.left ?? 0) - ($('.joint-paper')?.position()?.left ?? 0);
		y = event.pageY - ($('#paper-container')?.offset()?.top ?? 0) - ($('.joint-paper')?.position()?.top ?? 0);

    //obj.attributes.position = { x: x, y: y };
    
    // ajout de l'objet à l'éditeur
    this.addCanvasItem(obj, x, y);
  }

  allowDrop(event:any){
    event.preventDefault(); 
  }// renvoit vrai s'il existe un chemin possible entre q1 et q2id
  
  /**
   * vérifie qu'aucun chemin infini n'est créé en ajoutant un lien 
   * @param q1 
   * @param q2id 
   * @param originalId 
   */
  checkQuestionGoesToOther(q1:any, q2id:any, originalId:any) {

    // critère d'arret, à la première itération, 
    // on stocke l'id de la question depuis laquel on a commencé l'inspection
    if (!originalId)
        originalId = q1.model.attributes.id;

    else if (q1.model.attributes === originalId) {            
        return true;
    }

    // parcours de tous les liens de sortie de q1
    // 1 - si aucun lien ne va vers Q2 : vérifier le résultat de toutes les questions de destination vers q2
    // 2 - si un lien va vers Q2 : stop et renvoyer vrai
    var links = this.graph.attributes.cells.models.filter(function (x) { return x.attributes.type === 'link'; });

    var result = false;

    q1.model.attributes.options.forEach(function (opt:any) {
        var linkFromOptionToQ2 = links.find(function (l) { return l.attributes.source.port === opt.id && l.attributes.target.id === q2id; }); // remplacer true par destination = q2id
        if (linkFromOptionToQ2) {
            result = true;
            return;
        }
    });

    // aucun lien direct entre la question destination et la question source, on vérifie les sous-chemins
    if (!result) {
        var linksOut = links.filter(function (l) { return l.attributes.source.id === q1.model.attributes.id; });
        if (linksOut) {
            linksOut = linksOut.map(function (l) { return l.attributes.target.id; });
            var nextQuestions = this.graph.attributes.cells.models.filter(function (x) { return linksOut.indexOf(x.attributes.id) !== -1; });
            for (var i = 0; i < nextQuestions.length; i++) {
                var viewQNext = this.paper.findViewByModel(nextQuestions[i]);
                var subResult = this.checkQuestionGoesToOther(viewQNext, q2id, originalId);
                if (subResult)
                {
                    return true;
                }
            }
        }
    }

    return result;
}

/**
     * parcourt les éléments du questionnaire et les place sur le graph
     * @param {any} graph le graph de la libraire RappidJS
     * @param {any} survey le questionnaire chargé depuis l'API
     */
    loadSurvey(graph:any, survey:any) {

      var _this = this;

      var items = [];

      var links = [];
      // chargement des questions
      for (var k = 0; k < survey.questions.length; k++) {
          var q = survey.questions[k];
          q.options = q.options.sort((o1, o2) => { return o1.order - o2.order; });
          var question = new joint.shapes.qad.Question({
              id: q.id, dateMode: q.displayDateMode,
              display: q.displayMode, allowDecimal: q.allowDecimal,
              lengthOfTimeMode: q.displayLengthOfTimeMode,
              question: q.title, typequestion: q.type, userVariable: q.userVariable, userVariableId: q.userVariableId,
              options: q.options.map(function (o) { return { text: o.title, id: 'o' + o.id, positionX: o.x, positionY: o.y, size: o.size }; }),
              isTracked: q.isTracked, isImportant: q.isImportant,
              minValue: q.minValue, maxValue: q.maxValue, minLabel: q.minLabel, maxLabel: q.maxLabel,
              unit: q.unit
          });
          _this.addSurveyElementAt(graph, question, q.x, q.y, items);
          q.options.map(function (o) {
              if (o) {
                  o.links.map(function (l) {
                      var link = { q: question.id, link: l, question: question, showLabel: false };

                      // si la question source est de type qté et mode d'affichage slider : on affiche la condition d'application du lien
                      if (q.type === 3 && q.displayMode !== 2)
                          link.showLabel = true;

                      links.push(link);
                  });
              }
          });
      }

      // création des liens
      for (var m = 0; m < links.length; m++) {
          var l = links[m];
          var label = "";
          if (l.link.conditionType === 1 && l.link.conditionMinValue && l.link.conditionMaxValue) {
              label = l.link.conditionMinValue + ' - ' + l.link.conditionMaxValue;
          } else if (l.link.conditionType === 2 && l.link.conditionMinValue) {
              label = '> ' + l.link.conditionMinValue;
          } else if (l.link.conditionType === 0) {
              label = '*';
          } else if (l.link.conditionType === 3 && l.link.conditionMinValue) {
              label = '< ' + l.link.conditionMinValue;
          }

          var portInId = null;
          if (l.link.questionDestinationId) {
              var questionDestination = items.filter(function (x) { return x.id === 'qad.Question' + l.link.questionDestinationId; })[0];
              portInId = questionDestination.attributes.ports.items.filter(function (p) { return p.group === 'in'; })[0].id;
          }

          var link = new joint.dia.Link({
              id: l.link.id, source: { id: l.q, port: 'o' + l.link.sourceId }, target: _this.getIdDestinationFromLink(l, graph, portInId),
              criticity: l.link.criticity, attrs: {
                '.connection-wrap': { stroke: '#6a6c8a', 'stroke-width': 10, fill: 'none', 'opacity': 0 },
                '.link-tools': { display: 'none' },
                '.marker-vertices': { display: 'none' },
                '.marker-arrowhead': { display: 'none' },
                '.marker-target': { d: 'M 10 0 L 0 5 L 10 10 z', fill: 'rgba(22,215,36,.8)', stroke: 'rgba(22,215,36,.8)', opacity: 1 },
                '.connection': { stroke: 'rgba(22,215,36,.8)', 'stroke-width': 2, fill: 'none', 'pointer-events' : 'none' }
            },
              condition: { type: l.link.conditionType, start: l.link.conditionMinValue, stop: l.link.conditionMaxValue },
              router: {
                  name: 'manhattan'
              },
              connector: { name: 'rounded' }
          });

          if (label && l.showLabel) {
              //link.label(0, _this.getLabelLinkConfig(label));
          }

          _this.addSurveyElementAt(graph, link, null, null, items);
      }
      graph.resetCells(items);
      items = [];
  };

  getIdDestinationFromLink(l:any, graph:any, portInId:any) {

      if (l.link.actionDestination) {
          return { id: 'qad.Action' + l.link.actionDestination.id };
      }

      if (l.link.tipDestination) {
          return { id: 'qad.Tip' + l.link.tipDestination.id };
      }
      if (l.link.popupDestination) {
          return { id: 'qad.Popup' + l.link.popupDestination.id };
      }
      if (l.link.questionDestinationId) {
          var id = 'qad.Question' + l.link.questionDestinationId;
          return { id: id, port: portInId };
      }
  }

  addSurveyElementAt(graph:any, item:any, x:any, y:any, items: any) {
      item.id = item.attributes.id = item.attributes.type + item.id;
      if (x && y) {
          item.attributes.position = { x: x, y: y };
      }
      items.push(item);
      //item.addTo(graph);
  }

  /**
     * construit le <CreateSurveyDto> depuis les éléments du graph
     * @param {any} survey
     * @param {any} graph
     */
    getSurveyForSave = function () {
      var _this = this;
      var graph = this.graph.toJSON();
      // saving questions
      this.survey.questions = graph.cells.filter(function (x) { return x.type === 'qad.Question'; })
          .map(function (x) {
              return {
                  // questions iteration method
                  id: _this.getIdForItem(x),
                  graphId: x.id,
                  title: x.question,
                  type: parseInt(x.typequestion),
                  unit: x.unit,
                  x: x.position.x,
                  y: x.position.y,
                  userVariable: x.userVariable,
                  userVariableId: x.userVariableId,
                  isTracked: x.isTracked,
                  isImportant: x.isImportant,
                  minValue: x.minValue, maxValue: x.maxValue,
                  minLabel: x.minLabel, maxLabel: x.maxLabel,
                  displayDateMode: x.dateMode ? parseInt(x.dateMode) : 3,
                  displayMode: x.display ? parseInt(x.display) : 0,
                  allowDecimal: x.allowDecimal,
                  displayLengthOfTimeMode: x.lengthOfTimeMode ? parseInt(x.lengthOfTimeMode) : 0,
                  options: x.options.map(function (o) {
                      // options iteration method                  
                      return {
                          id: _this.getIdForItem(o), 
                          title: o.text, 
                          order: o.order,
                          graphId: o.id,
                          x: o.positionX, 
                          y: o.positionY, 
                          size: o.size
                      };
                  })
              };
          });
      
      var allLinks = graph.cells.filter(function (x) {
          return x.type === 'link';
      });

      this.survey.questions.forEach(q => {
        if (q.options){
          q.options.forEach(o => {
              var links = allLinks.filter(function (x) { return x.type === 'link' && x.source.port === o.graphId; });
              o.links = links.map(function (l) {

                  var link = {
                      id: _this.getIdForItem(l),
                      questionGraphId: l.target.id,
                      conditionType: null,
                      conditionMinValue: 0,
                      conditionMaxValue: 0
                  };

                  if (l.condition) {
                      link.conditionType = parseInt(l.condition.type);
                      link.conditionMinValue = l.condition.start;
                      link.conditionMaxValue = l.condition.stop;
                  }
                  return link;
              });
          });
        }
      });
  }

  getIdForItem(item) {
    var idWithoutType = null;
    if (item.type) {
        // for every objects except options
        idWithoutType = item.id.replace(item.type, ""); 
    }
    else if (item.id.indexOf('o') == 0 && item.id.indexOf("option") == -1) {
        // only for options
        idWithoutType = item.id.replace('o', '');
    }

    return idWithoutType;
  }

  isQuestionSelected(){
    return this.selected_question_object != null && this.selected_question_object.type == 'qad.Question';
  }

  isLinkSelected(){
    return this.selected_question_object != null && this.selected_question_object.type == 'link';
  }
}
